// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import VueMoment from 'vue-moment'
import * as firebase from 'firebase'
import VueResource from 'vue-resource'
import VueChatScroll from 'vue-chat-scroll'
import Notifications from 'vue-notification'
import VueLocalStorage from 'vue-localstorage'
import { Dropdown, Modal, Button, ButtonGroup } from 'bootstrap-vue/es/components';



// Bootstrap
Vue.use(Modal)
Vue.use(Button)
Vue.use(Dropdown)
Vue.use(ButtonGroup)

// Other
Vue.use(VueMoment)
Vue.use(Notifications)
Vue.use(VueChatScroll);
Vue.use(VueLocalStorage)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js